export const config = {
    addToCart: {
        resetDelay: 3000
    },
    cartConfirm: {
        initialHideDelay: 3000,
        resetHideDelay: 1000
    },
    pdpSlider: {
        maxSlidesForDesktop: 6,
        maxSlidesForMobile: 4,
        offsetHeightForControls: 155,
        offsetHeightForDesktop: 10,
        desktopWidth: 1024
    }
};

export default config;
